import { c as _c } from "react/compiler-runtime";
export default function LaptopEcon(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M84.71 68.01h-4.87V23c0-1.654-1.345-3-3-3H18.79l-.41.01-.033.031a3.004 3.004 0 0 0-2.567 2.969v45H11c-1.654 0-3 1.346-3 3v2.16c0 1.655 1.346 3 3 3h73.71c1.654 0 3-1.345 3-3v-2.16c0-1.654-1.346-3-3-3zm-66.93-45c0-.552.448-1 1-1L76.84 22a1 1 0 0 1 1 1v45H17.78V23.01zm67.93 50.16a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1v-2.16a1 1 0 0 1 1-1h73.71a1 1 0 0 1 1 1v2.16z" />;
    t2 = <path d="M72.98 24.18H22.65a2.913 2.913 0 0 0-2.91 2.91v35.87c0 1.655 1.345 3 3 3h50.15c1.654 0 3-1.345 3-3V27.09a2.913 2.913 0 0 0-2.91-2.91zm.91 38.78a1 1 0 0 1-1 1H22.74c-.551 0-1-.448-1-1V27.09c0-.502.408-.91.91-.91h50.33c.502 0 .91.408.91.91v35.87z" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <svg className={className} fill="currentColor" viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">{t1}{t2}</svg>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}